import { SideStepper } from '@components/navigation/stepper';
import { Overlay, XClearIcon } from 'bda-web-ui-components';
import { useEffect, type FC, type MouseEvent } from 'react';

import type { SideStepperProps } from '../stepper/sideStepper';

type Props = Pick<
  SideStepperProps,
  'items' | 'activeId' | 'completed' | 'title' | 'children'
> & {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
};

export const MobileStepperDrawer: FC<Props> = ({
  isOpen,
  onClose,
  items,
  activeId,
  completed,
  title,
  children,
  className,
}) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  const stop = (e: MouseEvent<HTMLDivElement>) => e.stopPropagation();

  return (
    <Overlay
      onClick={onClose}
      className={`fixed inset-0 z-[200] bg-black/40 transition-opacity duration-300 ease-in-out ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'} ${className ?? ''}`}
    >
      <div
        onClick={stop}
        role="dialog"
        aria-modal="true"
        className={`fixed inset-y-0 left-0 w-[88vw] max-w-[420px] max-h-[100dvh] rounded-r-[24px] rounded-l-none shadow-xl overflow-hidden transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
      >
        {/* Close button positioned against the edge of the drawer */}
        <button
          type="button"
          aria-label="Close menu"
          onClick={onClose}
          className="absolute right-6 top-6 z-[210] inline-flex h-10 w-10 items-center justify-center rounded-xl backdrop-blur-sm"
        >
          <XClearIcon className="h-5 w-5 fill-white" />
        </button>

        {/* We force FLUID width of the stepper into the drawer */}
        <SideStepper
          items={items}
          activeId={activeId}
          completed={completed}
          title={title}
          className="w-full h-full rounded-r-[24px] rounded-l-none"
        >
          {children}
        </SideStepper>
      </div>
    </Overlay>
  );
};

export default MobileStepperDrawer;
